// Toast pub-sub. Kept in its own file (not in the .jsx component) so
// the `react-refresh/only-export-components` rule stays happy — Vite's
// HMR only Fast-Refreshes modules that export ONLY components.
//
// API (callable from anywhere):
//   import { toast } from '@/lib/toast';
//   toast.success('Skizze hochgeladen');
//   toast.error('Speichern fehlgeschlagen: …');
//   toast.info('Lädt …');
//   const id = toast.error('…', { duration: 0, action: { label: 'Erneut versuchen', onClick } });
//   toast.dismiss(id);

const subscribers = new Set();
let nextId = 1;

// Optional global suppressor for `error` toasts. Used by apiClient
// during a device-limit eviction window (10 s) so the eviction toast
// from the interceptor isn't doubled by every individual caller that
// catches the 401 and toast.errors err.message itself (SubBar
// BERECHNEN, AppHeader Save, ProjectsPage Delete, …).
let errorSuppressor = null;

export function setErrorSuppressor(fn) {
  errorSuppressor = typeof fn === 'function' ? fn : null;
}

function emit(toast) {
  subscribers.forEach(fn => fn(toast));
}

function push(tone, message, opts = {}) {
  // `bypassSuppressor: true` lässt trusted internal callers (z.B. den
  // Eviction-Toast aus apiClient selbst) auch dann durch, wenn das
  // generelle Error-Suppressor-Fenster aktiv ist. Caller im User-Pfad
  // setzen das niemals — sie sollen ja unterdrückt werden.
  if (tone === 'error' && !opts.bypassSuppressor && errorSuppressor?.(message)) return -1;
  const id = nextId++;
  // Default lifetime: 6 s for info / success, 8 s for errors so the
  // user has more time to read a failure detail. `duration: 0`
  // disables auto-dismiss for sticky toasts.
  const duration = opts.duration ?? (tone === 'error' ? 8000 : 6000);
  emit({ id, tone, message, duration, action: opts.action ?? null });
  return id;
}

export const toast = {
  success(message, opts) { return push('success', message, opts); },
  error(message, opts)   { return push('error',   message, opts); },
  info(message, opts)    { return push('info',    message, opts); },
  dismiss(id)            { if (id > 0) emit({ dismiss: id }); }
};

// Internal: the <Toasts> renderer subscribes to receive new toasts.
export function subscribe(fn) {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}
